import React from 'react'

import Icon from 'components/Icon'
import { muiTheme } from 'mui-theme'

export const ObservabilityToolCustomIcon: React.FC = () => (
  <Icon
    css={{
      color: 'initial',
      width: muiTheme.spacing(4),
      height: muiTheme.spacing(4)
    }}
    icon="wavePulse"
  />
)
